export const TMDB_API_KEY = "8e4459c88645f93973697efc5d7d6a81";
export const TMDB_BASE_URL = "https://api.themoviedb.org/3";
//export const TMDB_BASE_URL = "http://localhost:8080/api/movies";
export const TMDB_IMAGE_BASE_URL = "https://image.tmdb.org/t/p/w500";